import { render, staticRenderFns } from "./BlockPhoneConfirmation.vue?vue&type=template&id=0a21659e&scoped=true&"
import script from "./BlockPhoneConfirmation.vue?vue&type=script&lang=ts&"
export * from "./BlockPhoneConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./BlockPhoneConfirmation.vue?vue&type=style&index=0&id=0a21659e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21659e",
  null
  
)

export default component.exports